import { render, staticRenderFns } from "./BookingLogs2.vue?vue&type=template&id=6157e6a8&scoped=true"
import script from "./BookingLogs2.vue?vue&type=script&lang=js"
export * from "./BookingLogs2.vue?vue&type=script&lang=js"
import style0 from "./BookingLogs2.vue?vue&type=style&index=0&id=6157e6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6157e6a8",
  null
  
)

export default component.exports